module.exports = __webpack_public_path__ + "onset-instructions-4.gif?bf385698808f9d7cdf43f0df8bb03aea";